import { UserConvertResponse } from "../../infra/api/service/user_api_convert";
import { Client } from "./client";
import { Customer } from "./customer";

export enum Role {
  Role_Unknown = 0,
  Role_Customer = 1,
  Role_Client = 2,
}

export enum Gender {
  Gender_Unknown = 0,
  Gender_Male = 1,
  Gender_Female = 2,
}

export class MessageState {
  constructor(
    public readonly roomID: string,
    public readonly isUnRead: boolean,
    public readonly unReadCount: number | Long
  ) {}
}

export class User {
  public static from(from: UserConvertResponse): User {
    return new User(
      from.email,
      from.role,
      from.client,
      from.customer,
      from.messageStateList,
      from.shouldUpdateCompany
    );
  }

  constructor(
    public readonly email: string,
    public readonly role: Role,
    public readonly client: Client | null,
    public readonly customer: Customer | null,
    public readonly messageStateList: MessageState[],
    public readonly shouldUpdateCompany: boolean
  ) {}
}



// WEBPACK FOOTER //
// ./src/domain/model/user.ts